<template lang="html">
  <boxwrap class="banner--inner">
    <toolbar></toolbar>
    <boxwrap-contents>
      <div class="banner-layout">
        <div class="banner-layout-con -top">
          <div class="banner-layout__main">
            <span>Main banner</span>
            <div
              class="banner-slider"
            >
              <ul class="banner-slider-list">
                <li
                  v-for="(main, x) in mainBanners"
                  :key="main.id"
                  v-if="mainActive===x"
                >
                  <div class="banner-slider--img" :style="`background-image: url(${imgPath}${main.image})`"></div>
                  <!-- <img :src="`${imgPath}${main.image}`"> -->
                </li>
              </ul>
            </div>
            <ul class="banner-slider-dot">
              <li
                v-for="(banner, x) in mainBanners"
                :key="x"
                @click="mainActive=x "
              ><span>{{x+1}}</span></li>
            </ul>
          </div>
          <div class="banner-layout__right">
            <span>Right Banner</span>
              <div
                class="banner-right--img"
                :style="`background-image: url(${imgPath}${rightBanner.image})`"
                v-if="rightBanner"
              ></div>
            <!-- <img
              :src="`${imgPath}${rightBanner.image}`"
              v-if="rightBanner"
            > -->
          </div>
        </div>
        <div class="banner-layout-con -sub">
          <div
            class="banner-layout__sub"
            v-for="(sub, x) in subItems"
            :key="x"
          >
            <!--has data -->
            <div
              class="banner-layout__sub--inner"
              :style="`background-image: url(${imgPath}${sub.image})`"
              v-if="sub"
            >
              <span>Sub {{x+1}}</span>
              <div class="banner-layout-play">
                <span>Play now</span>
              </div>
            </div>

            <!--has no data -->
            <div
              class="banner-layout__sub--inner"
              v-else
            >
              <span>Sub {{x+1}}</span>
              <i class="ico--no-image"></i>
              <div class="banner-layout-play">
                <span>Play now</span>
              </div>
            </div>

          </div>
        </div>
      </div>
      <button
        class="btn--create"
        @click="showCreate=true"
      >
        <i class="ico--create"></i>
      </button>

      <div class="tbl-outer">
        <check-data-list
          label="loading"
          v-if="isDataLoading || isEmpty"
          :isLoading="isDataLoading"
          :isEmpty="isEmpty"
        >
        </check-data-list>
        <tbl
          :scrollable="true"
          :dataLoading="isDataLoading"
          v-else
        >
          <tbl-inner >
            <tbl-head>
              <tbl-row>
                <tbl-td name="position">
                  position
                </tbl-td>
                <tbl-td name="type">
                  type
                </tbl-td>
                <tbl-td name="image">
                  image
                </tbl-td>
                <tbl-td name="link">
                  link
                </tbl-td>
                <tbl-td name="active">
                  active
                </tbl-td>
                <tbl-td name="created-at">
                  created-at
                </tbl-td>
                <tbl-td name="updated-at">
                  updated-at
                </tbl-td>
                <tbl-td name="actions">
                </tbl-td>
              </tbl-row>
            </tbl-head>
            <tbl-body>
              <tbl-row
                v-for="banner in banners"
                :key="banner.id"
              >
                <tbl-td name="position">
                  {{banner.order}}
                </tbl-td>
                <tbl-td name="type">
                  {{ types.find ((e) => { return e.val === banner.type }).display }}
                </tbl-td>
                <tbl-td name="image">
                  {{banner.image}}
                </tbl-td>
                <tbl-td name="link">
                  <div
                    class="input-wrap"
                    v-if="modify === banner.id"
                  >
                    <input
                      v-model="banner.link"
                      @keyup.enter="update(banner)"
                    >
                  </div>
                  <span v-else>
                    {{banner.link}}
                  </span>
                </tbl-td>
                <tbl-td name="active">
                  <checkbox
                    type="toggle"
                    class="toggle--inverted"
                    toggleA="active"
                    toggleB="inactive"
                    @click.native.prevent="update(banner, 'active')"
                  >
                    <input
                      type="checkbox"
                      v-model="banner.active"
                    />
                  </checkbox>
                </tbl-td>
                <tbl-td name="created-at">
                  {{ banner.created_at | date }}
                </tbl-td>
                <tbl-td name="updated-at">
                  {{ banner.updated_at | date }}
                </tbl-td>
                <tbl-td name="actions">
                  <button
                    class="btn--default"
                    @click="modify=banner.id"
                    v-if="banner.id !== modify"
                  >
                    <i class="ico--edit"></i>
                  </button>
                  <button
                    class="btn--clear"
                    v-if="banner.id === modify"
                    @click="modify=null"
                  >
                    <i class="ico--clear"></i>
                  </button>
                  <button
                    class="btn--modify"
                    v-if="banner.id === modify"
                    @click="update(banner)"
                  >
                    <i class="ico--save"></i>
                  </button>
                  <button class="btn--delete" @click="del(banner)">
                    <i class="ico--delete"></i>
                  </button>
                </tbl-td>
              </tbl-row>
            </tbl-body>
          </tbl-inner>
        </tbl>
      </div>

      <modal
        class="modal--change-agent"
        title="add item"
        v-if="showCreate"
        :activate="showCreate"
        @activate="showCreate = $event"
      >

        <template slot="body">
          <div class="form-con">
            <div class="form-items">
              <div class="form-lbl"><span>image</span></div>
              <div class="form-data">
                <div class="file-upload-wrap">
                  <label for="banner-img" class="file-upload--label">
  								  <i class="ico--upload"></i>
                    <input
                      type="file"
                      ref="file"
                      class="file-upload--input "
                      @change="attachImage"
                      id="banner-img"
                    />
  								</label>
                </div>
              </div>
            </div>
            <div class="form-items">
              <div class="form-lbl"><span>type</span></div>
              <div class="form-data">
                <select-list
                  :title="types[0].display"
                  :withReset="true"
                  v-model="data.type"
                >
                  <select-option
                    v-for="(type, e) in selTypes"
                    :value="type.val"
                    :name="type.display"
                    :key="e"
                  >
                    {{ type.display }}
                  </select-option>
                </select-list>
              </div>
            </div>

            <div class="form-items">
              <div class="form-lbl"><span>link</span></div>
              <div class="form-data">
                <div class="input-wrap">
                  <input v-model="data.link"/>
                </div>
              </div>
            </div>

            <div class="form-items">
              <div class="form-lbl"><span>order</span></div>
              <div class="form-data">
                <select-list
                  :title="data.order"
                  :withReset="true"
                  v-model="data.order"
                >
                  <select-option
                    v-for="(order, e) in orders"
                    :value="order"
                    :name="order"
                    :key="e"
                  >
                    {{ order }}
                  </select-option>
                </select-list>
              </div>
            </div>

          </div>
          <div
            class="img--body"
            :style="`background-image: url(${file})`"
          >
          </div>
        </template>

        <template slot="footer">
          <button
            class="btn--create -withlabel"
            @click="create()"
          >
            <i class="ico--save"></i>
            <span>create</span>
          </button>
        </template>
      </modal>
    </boxwrap-contents>
  </boxwrap>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'

//= =components
import Modal from '@/components/base/Modal'
import Checkbox from '@/components/base/Checkbox'
import CheckDataList from '@/components/base/CheckDataList'
import '@/components/base/select/Select'

export default {
  name: 'banner',

  components: {
    Modal,
    Checkbox,
    CheckDataList
  },

  created () {
    this.search()
  },

  data () {
    let types = [
      {
        val: 'main',
        display: 'main banner'
      },
      {
        val: 'sub',
        display: 'sub items'
      },
      {
        val: 'right',
        display: 'right banner'
      }
    ]

    return {
      showCreate: false,
      file: null,
      types,

      imgPath: process.env.VUE_APP_STATIC_ASSET_PATH,
      data: {
        type: types[0].val,
        image: null,
        link: '',
        order: 1
      },

      mainActive: 0,
      modify: null,

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false
      // slider
    }
  },

  computed: {
    ...mapState('settings-home', { banners: 'datas' }),

    selTypes () {
      let types = [
        {
          val: 'main',
          display: 'main banner'
        },
        {
          val: 'sub',
          display: 'sub items'
        },
        {
          val: 'right',
          display: 'right banner'
        }
      ]

      let check = []
      console.log(this.subItems.filter((e) => { return e !== null }), 'check')
      if (this.subItems.filter((e) => { return e !== null }).length >= 6) {
        check.push('sub')
      }

      if (this.rightBanner) {
        check.push('right')
      }

      return types.filter((e) => {
        return check.indexOf(e.val) < 0
      })
    },

    orders () {
      let data = this.banners.filter((e) => {
        return e.type === this.data.type
      })

      if (!data.length) return ['1']

      data = _.orderBy(data, 'order', 'asc')

      let nums = []
      let start = parseInt(data[data.length - 1].order) + 1

      // for (var x =  start; x < start + 4; x++) {
      //   let test = x
      //   nums.push(test.toString())
      // }

      nums = [start.toString()]

      return nums
    },

    mainBanners () {
      return _.orderBy(this.banners.filter((e) => {
        return e.type === 'main' && e.active
      }), 'order', 'asc')
    },

    rightBanner () {
      return this.banners.find((e) => {
        return e.type === 'right' && e.active
      })
    },

    subItems () {
      let banners = new Array(6).fill(null)
      for (var x = 0; x < banners.length; x++) {
        let b = this.banners.find((e) => {
          return e.type === 'sub' &&
            e.active &&
            parseInt(e.order) === (x + 1)
        })

        if (b) {
          banners[x] = b
        }
      }

      console.log(banners)
      return banners
    }
  },

  watch: {
    'data.type' () {
      this.data.order = this.orders[0]
    },
    showCreate () {
      this.data.order = this.orders[0]
    }
  },

  methods: {
    ...mapActions('settings-home', {
      createData: 'create',
      getData: 'get',
      updateData: 'update',
      deleteData: 'delete'
    }),

    attachImage (e) {
      if (e.target.files && e.target.files.length) {
        let fileReader = new FileReader()
        fileReader.onload = (event) => {
          this.file = event.target.result
        }
        fileReader.readAsDataURL(e.target.files[0])
      }
    },

    async search () {
      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.getData()

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.banners.length) {
        this.isEmpty = true
      }
    },

    async create () {
      if (this.$refs.file.files.length) {
        this.data.image = this.$refs.file.files[0]
      }

      await this.createData(this.data)
      this.showCreate = false
      this.search()
      this.data = {
        type: this.types[0].val,
        image: null,
        link: '',
        order: 1
      }
    },

    async update (data, type) {
      if (type === 'active') {
        data.active = !data.active
        console.log(data)
      }

      try {
        await this.updateData({ id: data.id, data })
        this.modify = null
        data.updated_at = new Date()
      } catch (err) {
        console.log(err)
      }
    },

    async del (item) {
      await this.deleteData(item.id)
      this.search()
    }
  }
}
</script>

<style lang="scss" scoped>
  .img--body {
    width: 100%;
    height: 100px;
    background: {
      position: center;
      size: cover;
      repeat: no-repeat;
    }
  }

  .banner-slider-list {
    &, li {
      width: 100%;
      height:100%;
    }
    img {
      width: 100%;
      height:100%;
    }
  }

  .banner-layout__right {
    img {
      width: 100%;
      height:95%;
    }
  }

  .tbl-outer {
    height: 300px;
    overflow: auto;
  }
</style>
